<template>
  <footer
    class="footer-nav"
  >
    <div class="wrap-container">
      <footer-breadcrumbs :data="breadcrumbs" />
      <footer-icon-links
        v-if="!storeInformation.isStore"
        :data="puffArea"
      />
      <footer-link-lists
        :data="linkCollection"
        :is-store="storeInformation.isStore"
      />
      <footer-sub-nav
        :address="address"
        :phone-number="phoneNumber"
        :is-store="storeInformation.isStore"
        :store-name="storeInformation.storeName"
      />
      <footer-modals />
    </div>
  </footer>
</template>

<script>
import footerBreadcrumbs from "./subcomponents/footer-breadcrumbs"
import footerIconLinks from "./subcomponents/footer-icon-links"
import footerLinkLists from "./subcomponents/footer-link-lists"
import footerSubNav from "./subcomponents/footer-sub-nav"
import footerModals from "./subcomponents/footer-modals"

// For footerIconLinks
// Set from backend (\Episerver\Content\Blocks\Enums\PuffIcon.cs)
import '#/Communication/Contact'
import '#/Alerts/Question'
import '#/Shop/CreditCard'
import '#/Communication/Email'

export default {
  components: {
    "footer-breadcrumbs": footerBreadcrumbs,
    "footer-icon-links": footerIconLinks,
    "footer-link-lists": footerLinkLists,
    "footer-sub-nav": footerSubNav,
    "footer-modals": footerModals
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    breadcrumbs: {
      type: Array,
      default () {
        return []
      }
    },
    linkCollection: {
      type: Array,
      default () {
        return []
      }
    },
    storeLinks: {
      type: Object,
      default: null
    },
    puffArea: {
      type: Array,
      default () {
        return []
      }
    },
    address: {
      type: String,
      default: ''
    },
    phoneNumber: {
      type: String,
      default: ''
    },
    profileName: {
      type: String,
      default: ''
    },
    storeInformation: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      date: new Date()
    }
  },
  mounted () {
    // adding storelinks object to footer links collections
    if (this.storeLinks && Object.keys(this.storeLinks).length > 0) {
      this.linkCollection.unshift(this.storeLinks)
    }
  }
}
</script>

<style lang="scss">
.footer-nav {
  background-color: $color-white;
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;

  @media print {
    display: none;
  }
}
</style>
